import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetQuestionsAnswersByApplicationGuid = createAsyncThunk(
  "SC_NT_RC_QuestionsAnswers/GetQuestionsAnswersByApplicationGuid",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_NT_RC_QuestionsAnswers/GetQuestionsAnswersByApplicationGuid",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateQuestionsAnswersList = createAsyncThunk(
  "SC_NT_RC_QuestionsAnswers/UpdateQuestionsAnswersList",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_NT_RC_QuestionsAnswers/UpdateQuestionsAnswersList",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const QuestionsAnswers = createSlice({
  name: "QuestionsAnswers",
  initialState: {
    //------------- GetQuestionsAnswers ---------------------
    QuestionsAnswers: [],
    loadingQuestionsAnswers: false,
    errorQuestionsAnswers: null,
    //------------- UpdateQuestionsAnswersList ---------------------
    UpdateQuestionsAnswers: {},
    loadingUpdateQuestionsAnswers: false,
    errorUpdateQuestionsAnswers: null,
  },
  reducers: {
    setQuestionsAnswers: (state, action) => {
      state.QuestionsAnswers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetQuestionsAnswersByApplicationGuid.pending,
        (state, action) => {
          console.log(action.payload, "action.payload");

          state.loadingQuestionsAnswers = true;
          state.QuestionsAnswers = action.payload;
          state.errorQuestionsAnswers = null;
        }
      )
      .addCase(
        GetQuestionsAnswersByApplicationGuid.fulfilled,
        (state, action) => {
          state.loadingQuestionsAnswers = false;
          state.QuestionsAnswers = action.payload;
        }
      )
      .addCase(
        GetQuestionsAnswersByApplicationGuid.rejected,
        (state, action) => {
          state.loadingQuestionsAnswers = false;
          state.QuestionsAnswers = action.payload;
        }
      );
    //------------------- UpdateQuestionsAnswers -----------------------------------
    builder
      .addCase(UpdateQuestionsAnswersList.pending, (state, action) => {
        state.loadingUpdateQuestionsAnswers = true;
        state.UpdateQuestionsAnswers = action.payload;
        state.errorUpdateQuestionsAnswers = null;
      })
      .addCase(UpdateQuestionsAnswersList.fulfilled, (state, action) => {
        state.loadingUpdateQuestionsAnswers = false;
        state.UpdateQuestionsAnswers = action.payload;
      })
      .addCase(UpdateQuestionsAnswersList.rejected, (state, action) => {
        state.loadingUpdateQuestionsAnswers = false;
        state.errorUpdateQuestionsAnswers = action.payload;
      });
  },
});
export const { setQuestionsAnswers } = QuestionsAnswers.actions;
export default QuestionsAnswers.reducer;
